import React from 'react';
export const Ticker = () => {
  const items = ['BUILT BY OPERATORS', 'NOT SOLD IN STORES', 'FIELD TESTED — FIELD PROVEN', 'AMERICAN WARRIOR BRAND', '12,400+ UNITS DEPLOYED', 'LIFETIME WARRANTY', "THE MASK THEY COULDN'T FIND — SO THEY BUILT IT", 'BLACKOUT UNIT™'];
  // Duplicate for seamless loop
  const tickerItems = [...items, ...items];
  return <div className="bg-dark-1 border-y border-acid-green/10 py-3 overflow-hidden flex whitespace-nowrap" data-id="element-1449">
      <div className="animate-marquee flex items-center" data-id="element-1450">
        {tickerItems.map((item, index) => <div key={index} className="flex items-center mx-8" data-id="element-1451">
            <span className="text-acid-green mr-4 text-sm inline-block w-2 h-2 bg-acid-green rotate-45" data-id="element-1452"></span>
            <span className="font-barlow font-bold text-sm tracking-[3px] text-text-body uppercase" data-id="element-1453">
              {item}
            </span>
          </div>)}
      </div>
    </div>;
};